export default "__VITE_ASSET__dgjHgz7q__"